import { Component, ViewEncapsulation } from "@angular/core";
import { MCBarSkeletonComponent } from "@maslul/common-components";

@Component({
    selector: 'mi-request-submission-methods-skeleton',
    templateUrl: './skeleton.html',
    styleUrls: ['./skeleton.scss'],
    imports: [
        MCBarSkeletonComponent
    ],
    encapsulation: ViewEncapsulation.None
})
export class RequestSubmissionMethodsSkeletonComponent {


}
